import { render, staticRenderFns } from "./Carbon.vue?vue&type=template&id=e1bd52c2&"
import script from "./Carbon.vue?vue&type=script&lang=js&"
export * from "./Carbon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports